import $ from 'jquery';

class NavigationItem {
    constructor(el, i) {

        this.render(el);
    }

    callback(entries) {

        var o = entries[0];

        this.navigation.attr('data-top', o.isIntersecting ? "true" : "false");

    }

    openMenu_CLICK(e) {
        this.mobileButton.trigger('open-menu');
    }


    render(el) {

        this.el = $(el);

        this.navigation = this.el.find('[data-ref="navigation"]')

        this.mobileButton = this.el.find('[data-ref="mobile-trigger"]');

        this.mobileMenu = this.el.find('[data-ref="mobile-menu"]');

        this.target = this.el.find('[data-ref="observer-target"]');


        let options = {

            rootMargin: '0px',
            threshold: 1.0
        }

        this.mobileButton.on('click', this.openMenu_CLICK.bind(this));
        if (this.target.length) {
            let observer = new IntersectionObserver(this.callback.bind(this), options);
            observer.observe(this.target.get(0));
        }
    }




}

class ComponentNavigation {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        new NavigationItem(el, index);
    }
}

export default ComponentNavigation;
